module.exports = "<div class=\"page-body\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <app-card [titleIcon]=\"'fas fa-exclamation-circle'\" [title]=\"'403 - Unauthorized'\" [classHeader]=\"true\">\n        <div class=\"text-center\" style=\"padding:20px;\">\n        <h1>Oops!</h1>\n        <h2>403 Unauthorized</h2>\n        <div>\n            Sorry, You are not authorized to view this page!\n        </div>\n        </div>\n      </app-card>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/errors/un-authorized/un-authorized.component.html
// module id = ./src/app/pages/errors/un-authorized/un-authorized.component.html
// module chunks = main